<script setup lang="ts">
import { PageSlotProvider } from '#layers/ui/public';
import WorkspaceChromePanelProvider from './WorkspaceChromePanelProvider.vue';
</script>

<template>
	<PageSlotProvider>
		<WorkspaceChromeHeader class="shrink-0">
			<slot name="header-title" />
		</WorkspaceChromeHeader>

		<div
			class="flex flex-1 flex-col overflow-hidden rounded-sm border bg-default min-block-0"
		>
			<WorkspaceChromePanelProvider>
				<div class="@container relative flex-1 overflow-x-hidden overflow-y-auto">
					<slot />
				</div>
			</WorkspaceChromePanelProvider>
		</div>
		<UploadProgress />
	</PageSlotProvider>
</template>
